module.exports = __webpack_public_path__ + "img/bg_avatar_male_16.fdc914e8.png";